import { Component,  Input } from '@angular/core';
import { JoiEvent, Ranking } from 'globals/store/events.data';
import { Session } from 'globals/store/programs.data';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { getXYFromEventAndWidth } from '../../helpers/helpers';
import { RankingDialogData, RankSelectDialogComponent } from '../../modules/sponsors/rank-select.dialog.component';
import { Wrapper } from '../wrapper.component';
import { MenuHoverButtonComponent } from '../buttons/menu-hover-button.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'performer-role-editor',
    template: `
<button *ngIf="!readOnly && !role" matButton class="secondary" (click)="editPerformerRole(performerId, $event)">+ PERFORMER ROLE</button>
<menu-hover-button *ngIf="!!role"
  id="entity-type"
  [mobileText]="true"
  [readOnly]="readOnly"
  [iconSelector]="'performers18'" 
  [hoverText]="'Performer role'" 
  [text]="typeof role === 'string' ? role : role?.name || 'Unnamed Role'"
  [tooltipLeft]="true"
  (click)="readOnly ? null : editPerformerRole(performerId, $event)">
</menu-hover-button>
`,
    styles: [`

`],
    standalone: true,
    imports: [MenuHoverButtonComponent, MatButtonModule, CommonModule],
})
export class PerformerRoleEditorComponent extends Wrapper<PerformerRoleEditorComponent> {
  @Input() readOnly: boolean
  @Input() role?: Ranking | string
  @Input() performerId: string
  @Input() session: Session
  @Input() programId: string
  @Input() event: JoiEvent

  async editPerformerRole(performerId: string, event: MouseEvent) {
    event.stopPropagation()
    const roleId = this.session.performerRoles[performerId] || null
    const { y: top, x: left } = getXYFromEventAndWidth(event, 300)
    const position = { top, left }
    const data: RankingDialogData = {
      position,
      ranks: this.event.performerRoles,
      selectedRankId: roleId,
      type: 'Performer role'
    }
  
    const oldRanksSerialized = JSON.stringify(data.ranks)
    const { ranks, selectedRankId } = await openDialogGetResult<{ ranks: Ranking[], selectedRankId: string }>(this.dialog, RankSelectDialogComponent, { width: '300px', disableClose: false, data, backdropClass: 'clear' }) // mutates data in place
    console.log({ ranks, selectedRankId, data })
    if (JSON.stringify(ranks) !== oldRanksSerialized) {
      this.eventService.updatePerformerRoles(ranks)
    }
    if (selectedRankId === roleId) return
    this.session.performerRoles[performerId] = selectedRankId
    this.saveSession()
  }

  saveSession() {
    if (!this.programId) throw new Error("Missing program ID")
    this.programService.updateSession(this.programId, this.session)
  }

}

